import type { SVGProps } from 'react';

export const BjornIllustrationHor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='280'
    height='276'
    viewBox='0 0 280 276'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    preserveAspectRatio='xMidYMid slice'
    {...props}>
    <g clipPath='url(#clip0_9265_2502)'>
      <rect width='280' height='276' fill='#F4E0CC' />
      <g opacity='0.4' filter='url(#filter0_g_9265_2502)'>
        <ellipse cx='183.5' cy='254.5' rx='122.5' ry='135.5' fill='#D8601E' />
      </g>
      <path
        d='M92.8798 171.697L130.848 157.742L216.345 152.282L268.424 170.003C284.151 175.355 294.826 189.993 295.109 206.594L298 376.215C244.204 389.176 124.603 400.696 60 366.134L67.4446 206.38C68.1725 190.759 78.1938 177.094 92.8798 171.697Z'
        fill='#50B2C2'
      />
      <path
        d='M130.848 157.742L216.345 152.282L181.282 278.769H169.273L130.848 157.742Z'
        fill='#F9EFE2'
      />
      <path
        d='M138.603 151.082V136.889L203.534 102.477C204.323 119.451 204.965 136.085 205.813 144.983L173.476 176.523L138.603 151.082Z'
        fill='#EEC7B1'
      />
      <path
        d='M173.476 176.524L138.603 151.082L130.848 157.562L159.427 190.084L173.476 176.524Z'
        fill='white'
      />
      <path
        d='M205.813 144.983L173.476 176.524L189.207 188.644L216.345 152.282L205.813 144.983Z'
        fill='white'
      />
      <g filter='url(#filter1_f_9265_2502)'>
        <ellipse cx='162.549' cy='135.001' rx='21.6145' ry='6.96041' fill='#E9BC9B' />
      </g>
      <path
        d='M121.25 130.172C129.689 138.478 164.452 141.778 183.203 135.121C195.451 130.772 204.497 123.724 204.22 117.6C203.699 106.141 203.157 93.3731 202.466 81.9691C202.466 81.9691 211.086 81.3139 209.621 72.237C208.155 63.1602 201.485 69.1468 201.485 69.1468C201.033 63.4981 200.716 60.0202 200.122 56.2684C196.277 32.0071 178.313 19.5234 161.352 19.5234C144.39 19.5234 128.656 23.3264 116.896 43.3587C109.207 56.7136 111.978 121.046 121.25 130.172Z'
        fill='#EEC7B1'
      />
      <g filter='url(#filter2_f_9265_2502)'>
        <ellipse cx='135.045' cy='97.5588' rx='9.84662' ry='9.84058' fill='#E9BC9B' />
      </g>
      <g filter='url(#filter3_f_9265_2502)'>
        <ellipse cx='169.148' cy='93.2385' rx='9.84662' ry='9.84058' fill='#E9BC9B' />
      </g>
      <path
        d='M96.8399 38.6911C95.9682 46.5323 102.071 57.8585 112.532 69.1847C115.322 63.6087 117.763 52.3406 118.635 47.4036C119.506 52.631 135.199 54.3735 178.788 29.1074C190.121 35.2061 198.839 46.5323 201.454 69.1847C204.069 62.7956 208.777 45.1383 206.685 25.6224C204.069 1.22748 184.89 2.96997 178.788 9.0687C176.753 4.71247 170.593 -4 162.224 -4C151.762 -4 97.7117 30.8499 96.8399 38.6911Z'
        fill='#EFB100'
      />
      <path
        d='M148.209 98.6C148.209 98.6 145.191 106.997 137.992 110.826C130.793 114.655 122.138 112.467 122.138 112.467C122.138 112.467 125.156 104.07 132.355 100.241C139.555 96.4118 148.209 98.6 148.209 98.6Z'
        fill='#EFB100'
      />
      <path
        d='M148.283 98.5783C148.283 98.5783 153.745 105.981 161.988 107.639C170.231 109.296 178.133 104.58 178.133 104.58C178.133 104.58 172.671 97.1766 164.428 95.5193C156.185 93.8621 148.283 98.5783 148.283 98.5783Z'
        fill='#EFB100'
      />
      <ellipse
        cx='1.68112'
        cy='4.56029'
        rx='1.68112'
        ry='4.56029'
        transform='matrix(0.996199 -0.0871027 0.0872088 0.99619 129.494 74.5762)'
        fill='#014558'
      />
      <ellipse
        cx='1.68112'
        cy='4.56029'
        rx='1.68112'
        ry='4.56029'
        transform='matrix(0.996199 -0.0871027 0.0872088 0.99619 171.34 71.0908)'
        fill='#014558'
      />
      <ellipse opacity='0.45' cx='133.369' cy='85.198' rx='12.2482' ry='5.0403' fill='#F9EFE2' />
      <path
        d='M140.346 94.0621C139.475 96.6759 145.137 98.2789 148.74 98.2789L147.321 76.6372C145.287 81.5743 141.044 91.9711 140.346 94.0621Z'
        fill='#EEC6B0'
      />
      <path
        d='M148.74 98.2789C145.137 98.2789 139.475 96.6759 140.346 94.0621C141.044 91.9711 145.287 81.5743 147.321 76.6372'
        stroke='#014558'
      />
      <path d='M143.876 85.1392L148.109 85.1392' stroke='#014558' />
      <ellipse opacity='0.45' cx='160.388' cy='85.198' rx='12.2482' ry='5.0403' fill='#F9EFE2' />
      <path
        d='M122.165 63.9571C125.29 60.2248 133.276 58.4313 138.604 61.1745'
        stroke='#EFB100'
        strokeWidth='5'
      />
      <path
        d='M181.331 60.5972C178.205 56.865 170.22 55.0715 164.892 57.8147'
        stroke='#EFB100'
        strokeWidth='5'
      />
      <path d='M172.396 115.2C170.714 119.28 166.872 120.84 163.51 120.72' stroke='#014558' />
      <mask
        id='mask0_9265_2502'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='130'
        y='152'
        width='87'
        height='137'>
        <path
          d='M130.848 157.742L216.345 152.282L181.282 278.769L175.563 288.767L169.273 278.769L130.848 157.742Z'
          fill='#E9BC9B'
        />
      </mask>
      <g mask='url(#mask0_9265_2502)'>
        <path
          d='M161.708 187.924L173.476 176.523L186.445 186.604L174.917 200.164L193.53 287.53L174.917 303.01L156.425 287.53L174.917 200.164L161.708 187.924Z'
          fill='#D8601E'
        />
      </g>
      <path
        d='M250.868 164.042L216.345 152.282L175.518 288.85L224.991 231.726L213.944 222.126H227.873L250.868 164.042Z'
        fill='#42A0AF'
      />
      <path
        d='M102.028 168.363L130.972 157.681L175.624 288.874L125.804 233.887L132.289 224.286L122.202 224.286L102.028 168.363Z'
        fill='#42A0AF'
      />
      <ellipse
        cx='24.2649'
        cy='5.01736'
        rx='24.2649'
        ry='5.01736'
        transform='matrix(0.931352 -0.36412 0.364507 0.931201 209.537 255.695)'
        fill='#014558'
      />
      <path
        d='M225.765 181L256.416 259.879L219.265 275.187L218.039 251.637C213.22 253.16 202.599 254.157 197.888 253.032C194.095 249.869 185.726 228.067 191.644 214.39C197.378 210.195 211.937 207.196 220.88 209.64C220.88 209.64 218.197 195.527 219.489 191.36C220.581 187.03 222.486 183.116 225.765 181Z'
        fill='#EEC6B0'
      />
      <line
        y1='-0.5'
        x2='16.1102'
        y2='-0.5'
        transform='matrix(0.983889 -0.178779 0.178991 0.983851 189.482 225.19)'
        stroke='#014558'
      />
      <line
        y1='-0.5'
        x2='16.1102'
        y2='-0.5'
        transform='matrix(0.983889 -0.178779 0.178992 0.983851 190.888 236.047)'
        stroke='#014558'
      />
      <line
        y1='-0.5'
        x2='16.1102'
        y2='-0.5'
        transform='matrix(0.983889 -0.178779 0.178991 0.983851 193.805 246.312)'
        stroke='#014558'
      />
      <path d='M218.026 251.648C220.422 250.767 221.626 250.127 223.55 248.768' stroke='#014558' />
      <path
        d='M282.905 307.275C271.687 324.919 250.502 361.069 250.003 361.998L211.665 260.795C213.734 262.706 224.084 260.782 235.794 256.204C247.443 251.65 256.318 246.078 256.629 243.258L282.905 307.275Z'
        fill='#50B2C2'
      />
      <ellipse cx='254.806' cy='258.792' rx='2.40161' ry='2.40015' fill='#006D86' />
      <path d='M256.34 242.621L275.905 290.29M211.632 260.237L240.636 337.213' stroke='#014558' />
      <path
        d='M264.249 261.898C265.259 264.478 255.96 270.526 243.479 275.405C230.998 280.285 220.061 282.149 219.051 279.568'
        stroke='#014558'
      />
      <path d='M108.753 382.936L106.351 260.528' stroke='#014558' />
      <path
        opacity='0.2'
        d='M112.595 68.9968C111.475 59.6763 110.242 39.7871 114.276 34.7948C119.32 28.5544 163.99 8.27324 170.714 10.9134C175.113 12.6404 179.801 24.2342 179 29.1545C181.762 21.714 187.406 12.9535 193.049 14.7536C198.693 16.5537 206.378 28.7945 201.575 68.6368'
        stroke='#965808'
      />
      <path
        opacity='0.2'
        d='M118.599 47.2758C131.808 48.5959 158.346 24.2344 166.271 22.9144C172.612 21.8583 177.319 26.5546 178.88 29.0347C182.963 22.4343 187.165 19.3141 191.608 20.0342C196.051 20.7542 202.536 26.7546 201.455 68.037'
        stroke='#965808'
      />
    </g>
    <defs>
      <filter
        id='filter0_g_9265_2502'
        x='-39'
        y='19'
        width='445'
        height='471'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feTurbulence
          type='fractalNoise'
          baseFrequency='0.90909087657928467 0.90909087657928467'
          numOctaves='3'
          seed='1237'
        />
        <feDisplacementMap
          in='shape'
          scale='200'
          xChannelSelector='R'
          yChannelSelector='G'
          result='displacedImage'
          width='100%'
          height='100%'
        />
        <feMerge result='effect1_texture_9265_2502'>
          <feMergeNode in='displacedImage' />
        </feMerge>
      </filter>
      <filter
        id='filter1_f_9265_2502'
        x='132.934'
        y='120.041'
        width='59.2291'
        height='29.9209'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='4' result='effect1_foregroundBlur_9265_2502' />
      </filter>
      <filter
        id='filter2_f_9265_2502'
        x='117.199'
        y='79.7183'
        width='35.6932'
        height='35.6812'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='4' result='effect1_foregroundBlur_9265_2502' />
      </filter>
      <filter
        id='filter3_f_9265_2502'
        x='151.302'
        y='75.3979'
        width='35.6932'
        height='35.6812'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='4' result='effect1_foregroundBlur_9265_2502' />
      </filter>
      <clipPath id='clip0_9265_2502'>
        <rect width='280' height='276' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
